import { Fragment, useEffect, useState } from "react";
import Footer from "../components/footer";
import {
  Typography,
} from "@material-tailwind/react";
import { useParams } from "react-router-dom";

import { API_URL } from "../App.js";

const defaultImage = "/Logo_AdaLab.png";

const InfraestructuraID = () => {
  const { infraestructuraId } = useParams();
  const [data, setData] = useState(null);
  const [imagenSeleccionada, setImagenSeleccionada] = useState(null);

  useEffect(() => {
    fetch(API_URL + `infraestructura/${infraestructuraId}`)
      .then((response) => response.json())
      .then((data) => {
        setData(data.data);
        // Establecer la primera imagen como seleccionada
        if (data.data.infraestructura.imagenes && data.data.infraestructura.imagenes.length > 0) {
          setImagenSeleccionada(data.data.infraestructura.imagenes[0].imagen);
        } else if (data.data.infraestructura.ruta_imagen) {
          setImagenSeleccionada(data.data.infraestructura.ruta_imagen);
        }
      })
      .catch((error) => {
        console.log("Error al obtener los datos de infraestructura:", error);
      });
  }, [infraestructuraId]);

  if (!data) {
    return (
      <>
        <br />
        <Typography variant="h3" className="font-bold font-sans" color="black">
          Cargando...
        </Typography>
      </>
    );
  }

  const imagenPrincipal = imagenSeleccionada || data.infraestructura.ruta_imagen || process.env.PUBLIC_URL + defaultImage;

  return (
    <div className="flex flex-col flex-grow">
      <section className="text-gray-600 body-font pt-4">
        <div className="container px-5 mx-auto flex flex-col">
          <div className="lg:w-6/6 mx-auto">
            {/* Título */}
            <h4 className="title-font sm:text-4xl text-3xl font-medium text-gray-900 font-sans mb-3">
              {data.infraestructura.nombre}
            </h4>
            
            {/* Categoría con icono de tag */}
            <div className="flex items-center gap-2 mb-6">
              <svg 
                className="w-5 h-5 text-[#1a365d]" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24" 
                xmlns="http://www.w3.org/2000/svg"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" 
                />
              </svg>
              <span className="inline-block bg-[#1a365d] text-white px-4 py-1.5 rounded-full text-sm font-sans font-semibold">
                {data.infraestructura.categoria_nombre}
              </span>
            </div>

            <div className="flex flex-col lg:flex-row gap-8 mt-6">
              {/* Columna izquierda - Información */}
              <div className="lg:w-1/2">
                <div className="mb-6">
                  <h5 className="text-xl font-bold text-gray-900 mb-3 font-sans">Descripción</h5>
                  <p className="leading-relaxed text-base text-justify font-sans">
                    {data.infraestructura.descripcion}
                  </p>
                </div>

                {data.infraestructura.especificaciones_tecnicas && (
                  <div className="mb-6">
                    <h5 className="text-xl font-bold text-gray-900 mb-3 font-sans">
                      Especificaciones Técnicas
                    </h5>
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <p className="leading-relaxed text-base text-justify font-sans whitespace-pre-line">
                        {data.infraestructura.especificaciones_tecnicas}
                      </p>
                    </div>
                  </div>
                )}

                {data.infraestructura.fecha_adquisicion && (
                  <div className="flex items-center gap-2 mb-4">
                    <svg
                      className="h-5 w-5 text-indigo-700"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5"
                      />
                    </svg>
                    <span className="font-bold font-sans">Fecha de Adquisición:</span>
                    <span className="text-gray-800 font-sans">
                      {new Date(data.infraestructura.fecha_adquisicion).toLocaleDateString('es-ES', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                      })}
                    </span>
                  </div>
                )}
              </div>

              {/* Columna derecha - Galería de imágenes */}
              <div className="lg:w-1/2">
                <div className="rounded-lg overflow-hidden shadow-lg mb-4">
                  <img
                    className="object-cover object-center w-full h-96"
                    alt={data.infraestructura.nombre}
                    src={imagenPrincipal}
                  />
                </div>

                {/* Miniaturas de la galería */}
                {data.infraestructura.imagenes && data.infraestructura.imagenes.length > 0 && (
                  <div className="grid grid-cols-4 gap-2 mb-6">
                    {/* Imagen principal si existe */}
                    {data.infraestructura.ruta_imagen && (
                      <div
                        className={`cursor-pointer rounded-lg overflow-hidden border-2 ${
                          imagenSeleccionada === data.infraestructura.ruta_imagen
                            ? 'border-[#1a365d]'
                            : 'border-transparent'
                        } hover:border-[#1a365d] transition-all`}
                        onClick={() => setImagenSeleccionada(data.infraestructura.ruta_imagen)}
                      >
                        <img
                          src={data.infraestructura.ruta_imagen}
                          alt="Principal"
                          className="w-full h-20 object-cover"
                        />
                      </div>
                    )}
                    
                    {/* Imágenes adicionales */}
                    {data.infraestructura.imagenes.map((img, index) => (
                      <div
                        key={img.id}
                        className={`cursor-pointer rounded-lg overflow-hidden border-2 ${
                          imagenSeleccionada === img.imagen
                            ? 'border-[#1a365d]'
                            : 'border-transparent'
                        } hover:border-[#1a365d] transition-all`}
                        onClick={() => setImagenSeleccionada(img.imagen)}
                        title={img.descripcion || `Imagen ${index + 1}`}
                      >
                        <img
                          src={img.imagen}
                          alt={img.descripcion || `Imagen ${index + 1}`}
                          className="w-full h-20 object-cover"
                        />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* Sección de videos */}
            {data.infraestructura.videos && data.infraestructura.videos.length > 0 && (
              <div className="mt-10">
                <h5 className="text-2xl font-bold text-gray-900 mb-6 font-sans">Videos</h5>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {data.infraestructura.videos.map((video, index) => (
                    <div key={video.id} className="bg-white rounded-lg shadow-md overflow-hidden">
                      <div className="relative" style={{ paddingBottom: "56.25%", height: 0 }}>
                        <iframe
                          className="absolute top-0 left-0 w-full h-full"
                          src={`https://www.youtube.com/embed/${video.video_id}`}
                          title={video.titulo}
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        ></iframe>
                      </div>
                      <div className="p-4">
                        <h6 className="font-bold text-gray-900 font-sans">{video.titulo}</h6>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default InfraestructuraID;
